import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { CheckIcon } from 'lucide-react';

import { cn } from '@/lib/utils';

function Checkbox({ className, ...props }: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        'peer size-4 shrink-0 cursor-pointer rounded-sm border border-primary-10 outline-none transition-colors',
        'hover:border-primary-20',
        'data-[state=checked]:border-highlight-default data-[state=checked]:bg-highlight-default data-[state=checked]:text-white',
        'focus-visible:ring-2 focus-visible:ring-primary-20/50',
        'disabled:cursor-not-allowed disabled:opacity-70',
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="flex items-center justify-center text-current"
      >
        <CheckIcon className="size-3 stroke-[2.5] text-white" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
